var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.353 2.995-7.425 7.424a.5.5 0 0 1-.707 0l-.707-.707L.647 6.845a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0l2.514 2.514 6.364-6.364a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707z",
    fill: "currentColor"
  })));
};

export default SvgCheckMark;